export const enterpriseIntakeDefaultValues = {
  fullName: "",
  corporateEmail: "",
  companyName: "",
  jobTitle: "",
  companyWebsite: "",

  purchaseDecisionMaker: "",
  currentToolOrAdleStatus: "",
  currentToolOrAdleStatusOther: "",
  operatingCountriesCount: "",
  creativesVaryByMarket: "",

  selectedAdleModules: [],
  primaryGoal: "",
  primaryGoalOther: "",

  module1BrandsOrVisualIdentitiesCount: "",
  module1IndependentBrandConfigsCount: "",
  module1MonthlyNewImagesCount: "",
  module1FormatsPerPieceAvg: "",
  module1MonthlyAdditionalEditsCount: "",
  module1MonthlyVideosCount: "",
  module1MonthlyImageAnimationsCount: "",
  module1VersionsPerPieceBeforeApproval: "",
  module1CreativeVolumeVariation: "",
  module1PeakMonthPiecesCount: "",

  module2AdAccountsOrAdvertisersCount: "",
  module2MonthlyCampaignsCount: "",
  module2MonthlyOptimizationsCount: "",
  module2CampaignVolumeVariation: "",
  module2PeakMonthCampaignsCount: "",

  module3CampaignsToImportCount: "",
  module3ImportPlatforms: [],
  module3ImportPlatformsOther: "",

  module4MonthlyOrganicPostsCount: "",
  module4SchedulingNetworks: [],
  module4SchedulingNetworksOther: "",
  module4PostCreationSource: "",

  activeAdvertisersMonth1: "",
  activeAdvertisersMonth1Other: "",
  totalAdvertisers60to90Days: "",
  totalAdvertisers60to90DaysOther: "",

  platformUsersCount: "",
  creditsManagementModel: "",
  creditsManagementModelOther: "",

  monthlyEstimatedCredits: "",
  monthlyEstimatedCreditsOther: "",

  phase1PaidChannels: [],
  phase1PaidChannelsOther: "",
  monthlyAdSpendRange: "",
  monthlyAdSpendRangeOther: "",
  hasAdminAccessPhase1: "",
  hasAdminAccessPhase1Other: "",

  supportLevel: "",
  supportLevelOther: "",
  platformManagementModel: "",
  csmCadence: "",
  csmCadenceOther: "",
  contractFormat: "",
  contractFormatOther: "",
  implementationTimeline: "",
  implementationTimelineOther: "",
  whiteLabelRequirement: "",
  urgencyDeadlineOrEvent: "",
  estimatedToolBudgetRange: "",
  securityRequirements: [],
  securityRequirementsOther: "",

  additionalNotes: "",
};
